import _extends from "@babel/runtime/helpers/extends";
import React, { useRef } from 'react';
import { registerPlayableModule } from '@wix/wix-vod-player';
import { SettingsModule } from '@wix/wix-vod-playable-settings';
import { Facebook } from './Facebook';
import { SourceType } from './Player.types';
import { Youtube } from './Youtube';
import { Vimeo } from './Vimeo';
import { Player } from './Player';
import { VIDEO_EVENTS } from 'playable';
import { getPlayerInstance } from './OPGPlayerInstance';
function getComponentByType(type) {
  switch (type) {
    case SourceType.Youtube:
      return Youtube;
    case SourceType.Facebook:
      return Facebook;
    case SourceType.Vimeo:
      return Vimeo;
    default:
      return Player;
  }
}
registerPlayableModule('settings', SettingsModule);
export const OPPlayer = props => {
  const {
    type,
    resolutions,
    onProgress,
    onPlayerReady,
    onError,
    disableSeekForward,
    ...rest
  } = props;
  const Component = getComponentByType(type);
  const playerRef = useRef(null);
  const playerReady = player => {
    var _playerRef$current;
    playerRef.current = getPlayerInstance(player, type);
    onProgress && playerRef.current.on(VIDEO_EVENTS.CURRENT_TIME_UPDATED, _ref => {
      let {
        percent
      } = _ref;
      onProgress(percent * 100);
    });
    onError && ((_playerRef$current = playerRef.current) == null ? void 0 : _playerRef$current.on(VIDEO_EVENTS.ERROR, onError));
    onPlayerReady == null || onPlayerReady(playerRef.current);
  };
  return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
    resolutions: resolutions == null ? void 0 : resolutions.filter(_ref2 => {
      let {
        quality
      } = _ref2;
      return !!quality;
    }),
    onPlayerReady: playerReady,
    disableSeekForward: disableSeekForward
  }));
};
OPPlayer.displayName = 'OPPlayer';
//# sourceMappingURL=OPPlayer.js.map